module.exports = __webpack_public_path__ + "assets/img/0809.7b8b98c4.png";